import type {CourseExpandedCommon} from '../../../api/course';

export function isCourseAvailableToJoin(course: CourseExpandedCommon) {
  if (course.program.is_closed) {
    return false;
  }

  const groupSize = course.edition?.group_size ?? 0;

  return (
    course.status === 'planned' ||
    (course.status === 'ongoing' &&
      course.counters.memberships.accepted < groupSize)
  );
}
